import { IonButton } from "@ionic/react";
import { useHistory, useLocation } from "react-router";
import Page from "../components/Page";
const Home: React.FC = () => {
  return (
    <Page title="Donations">
      <DOnate />
    </Page>
  );
};

export default Home;

const DOnate = () => {
  const history = useHistory();
  return (
    <div className="flex_cell_inner">
      <section
        className="av_textblock_section w-full "
        itemScope={true}
        itemType="https://schema.org/CreativeWork"
      >
        <div
          className="flex justify-center text-center avia_textblock  "
          itemProp="text"
        >
          <p className=" font-extralight text-center md:w-[60%] p-8 px-10 border border-r-15 ">
            Though you are free to spend time with anyone you choose, you are
            here with me and I am quite excited! Here is the donation list for
            my time, companionship and entertainment. All rates are
            non-negotiable. Compensation is for my time only. What we do during
            that time is between two consenting adults.
          </p>
        </div>
      </section>
      {/* <div className=" hr av-kknx9lx4-368c68f1c720fac9ca9de3eee91eb00c hr-short  avia-builder-el-6  el_after_av_textblock  el_before_av_textblock  hr-center ">
        <span className="hr-inner ">
          <span className="hr-inner-style"></span>
        </span>
      </div> */}
      <section
        className=" mt-5 av_textblock_section flex justify-center text-center  w-full "
        itemScope={true}
        itemType="https://schema.org/CreativeWork"
      >
        <div
          className="flex justify-center text-center avia_textblock w-full  "
          itemProp="text"
        >
          <div
            className=" md:w-[60%] w-[100vh] border border-r-15 p-3 "
            itemProp="text"
          >
            <h3 style={{ textAlign: "center" }}>DONATION RATES</h3>
            <div className="h-4" />
            <p className="text-base text-center font-extralight  ">
              60 mins <span className="text-sm">🌹🌹🌹🌹🌹🌹🌹🌹🌹</span>{" "}
              500{" "}
            </p>
            <p className="text-base text-center font-extralight  ">
              90 mins <span className="text-sm">🌹🌹🌹🌹🌹🌹🌹🌹🌹</span>{" "}
              650{" "}
            </p>
            <p className="text-base text-center font-extralight  ">
              2 hrs{" "}
              <span className="text-sm">🌹🌹🌹🌹🌹🌹🌹🌹🌹🌹🌹</span> 800{" "}
            </p>
            <p className="text-base text-center font-extralight  ">
              3 hrs <span className="text-sm">🌹🌹🌹🌹🌹🌹🌹🌹🌹🌹</span>{" "}
              1,050{" "}
            </p>
            <p className="text-base text-center font-extralight  ">
              Overnight <span className="text-sm">🌹🌹🌹🌹🌹🌹🌹🌹</span>{" "}
              3,500{" "}
            </p>
            {/* <p className="text-base text-center font-extralight  ">
            Dinner, Movie, 2 Hours BCD 1,500
          </p>
          <p className="text-base text-center font-extralight  ">
            80’s theme Dinner, Movie, BCD ,1500
          </p> */}
            <div className="h-4" />
            <h3 className="text-base text-center  ">OUTCALL TRAVEL FEE</h3>
            <p className="text-base text-center font-extralight  ">
              For outcall dates, please add a 50 travel fee.
            </p>
            <div className="h-4" />
            <h3 className="text-base text-center  ">EXTENDED EXPERIENCES</h3>
            <p className="text-base text-center font-extralight  ">
              Please note that extended experiences are for regulars only.
            </p>
            <div className="h-4" />
            <h3 className="text-base text-center  ">STRICTLY SOCIAL</h3>
            <p className="text-base text-center font-extralight  ">
              200 per hour
            </p>
            <div className="h-4" />
            <h3 className="text-base text-center  ">AVAILABILITY</h3>
            <p className="text-base text-center font-extralight  ">
              7am – 7pm / 7 Days a Week
            </p>
          </div>
        </div>
      </section>

      <div className="flex flex-1 justify-center pt-[2%] ">
        <IonButton fill="outline" onClick={() => {
         history.replace("/contact");
        }} className="avia_iconbox_title">
          Donate
        </IonButton>
      </div>
    </div>
  );
};

const Table = () => {
  return (
    <table style={{ width: "100%" }} className="table table-striped">
      {" "}
      <tbody>
        {" "}
        <tr>
          {" "}
          <th>Model</th> <td className="pl-4">Nicki Woods</td>{" "}
        </tr>{" "}
        <tr>
          {" "}
          <th>Age </th> <td className="pl-4">27</td>{" "}
        </tr>{" "}
        <tr>
          {" "}
          <th>Height </th> <td className="pl-4">5'5 ft</td>{" "}
        </tr>{" "}
        <tr>
          {" "}
          <th>Weight </th> <td className="pl-4">135 lbs</td>{" "}
        </tr>{" "}
        {/* <tr>
          {" "}
          <th>Measurements </th> <td className="pl-4">88 - 62 - 89 cm // US 34 - 24 - 35</td>{" "}
        </tr>{" "} */}
        {/* <tr>
          {" "}
          <th>Dress size </th> <td className="pl-4">34-36// US 4-6</td>{" "}
        </tr>{" "} */}
        <tr>
          {" "}
          <th>Cup size </th> <td className="pl-4">36D</td>{" "}
        </tr>{" "}
        <tr>
          {" "}
          <th>Eye color </th> <td className="pl-4">Brown</td>{" "}
        </tr>{" "}
        <tr>
          {" "}
          <th>Hair color </th> <td className="pl-4">Black</td>{" "}
        </tr>{" "}
        <tr>
          {" "}
          <th>Hair length </th> <td className="pl-4">Long</td>{" "}
        </tr>{" "}
        <tr>
          {" "}
          <th>Build </th> <td className="pl-4">All natural, beautiful face</td>{" "}
        </tr>{" "}
        {/* <tr>
          {" "}
          <th>Tattoo </th> <td className="pl-4">Yes</td>{" "}
        </tr>{" "} */}
        {/* <tr>
          {" "}
          <th>Professional background </th> <td className="pl-4">Escort</td>{" "}
        </tr>{" "} */}
        <tr>
          {" "}
          <th>Languages </th>{" "}
          <td className="pl-4">Spanish ( fluent ), English ( fluent )</td>{" "}
        </tr>{" "}
        <tr>
          {" "}
          <th>Nationality </th> <td className="pl-4">Cuban</td>{" "}
        </tr>{" "}
        {/* <tr>
          {" "}
          <th>Cuisine </th> <td className="pl-4">French, mediterranean, japanese</td>{" "}
        </tr>{" "} */}
        {/* <tr>
          {" "}
          <th>Drinks </th> <td className="pl-4">Gin Tonic, Champagner, Wine</td>{" "}
        </tr>{" "} */}
        {/* <tr>
          {" "}
          <th>Clothing style </th> <td className="pl-4">Casual, elegant</td>{" "}
        </tr>{" "} */}
        <tr>
          {" "}
          <th>Perfume </th> <td className="pl-4">Chanel</td>{" "}
        </tr>{" "}
        {/* <tr>
          {" "}
          <th>Gift ideas </th>{" "}
          <td className="pl-4">
            I love to explore and experience new things! Whether at a dinner, a
            jet ski ride or later in the hotel ;) - I get the most enjoyment
            from simply having fun together! Let's spend moments together that
            we will never forget!
          </td>{" "}
        </tr>{" "} */}
        <tr>
          {" "}
          <th>Character </th>{" "}
          <td className="pl-4">
            Communicative, educated, uncomplicated, positive
          </td>{" "}
        </tr>{" "}
        {/* <tr>
          {" "}
          <th>Interests </th> <td className="pl-4">Travel, profound Conversations, eat good</td>{" "}
        </tr>{" "} */}
        {/* <tr>
          {" "}
          <th>Travel availability </th> <td className="pl-4">Worldwide</td>{" "}
        </tr>{" "} */}
        {/* <tr>
          {" "}
          <th>Duo partner </th> <td className="pl-4">No</td>{" "}
        </tr>{" "}
        <tr>
          {" "}
          <th>Couples </th> <td className="pl-4">No</td>{" "}
        </tr>{" "} */}
      </tbody>{" "}
    </table>
  );
};
